App.factory('MultiFactorAuthSendOtp', ['restmod', '$api', (restmod, $api) => {
  return restmod.model().mix({
    $extend: {
      Model: {
        $send_token: function(params = {}) {
          return $api('POST', '/auth/mfa/send', params);
        }
      }
    }
  })
}])
